import { clientFetch } from 'app/utils/client-fetch';
import * as types from './types';
import config from 'app/config';
import { Cabinet } from 'app/components/shared/interfaces';

export const apiGetArcadeCabinets = (arcadeId: string): Promise<{ cabinets: Cabinet[] }> =>
    clientFetch({
        url: `${config.ARCADE_API_URL}/arcades/${arcadeId}/cabinets`,
        type: types.GET_ARCADE_CABINETS
    });

export const apiGetArcadeCabinet = cabinetId => {
    return clientFetch({
        url: `${config.ARCADE_API_URL}/cabinets/${cabinetId}`,
        type: types.GET_ARCADE_CABINET
    });
};

export const apiCreateArcadeCabinet = (
    cabinet: {
        arcadeId: string;
        bannerImage?: string;
        image?: string;
        metaDataValues?: string;
        romId: string;
    }
) => {
    return clientFetch({
        method: 'POST',
        body: cabinet,
        url: `${config.ARCADE_API_URL}/cabinets`,
        type: types.POST_ARCADE_CABINET
    });
};

export const apiUpdateArcadeCabinet = (
    cabinetId: string,
    cabinet: {
        bannerImage?: string;
        image?: string;
        metaDataValues?: string;
        romId: string;
    }
) => {
    return clientFetch({
        method: 'PUT',
        body: cabinet,
        url: `${config.ARCADE_API_URL}/cabinets/${cabinetId}`,
        type: types.PUT_ARCADE_CABINET
    });
};

export const apiDeleteArcadeCabinet = cabinetId => {
    return clientFetch({
        method: 'DELETE',
        url: `${config.ARCADE_API_URL}/cabinets/${cabinetId}`,
        type: types.DELETE_ARCADE_CABINET
    });
};
